var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7c0cdc47ba496194ca4ceddf235bf98d478a7485"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"7c0cdc47ba496194ca4ceddf235bf98d478a7485"};
      